/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

// UTILS
import { getClientReportsData } from 'state/actions/reportsState/reports_status';
import { updatePageDetails, changePage, downloadLink, displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui';
import { generateRunReportParamString } from 'utils/fetchcontenthelpers';
import { batchActions } from 'redux-batched-actions';
import * as reportsAPIUtil from 'utils/api/reports';


// ACTIONS
import { updateMode, setLibraryProcessing } from 'state/actions/reportsState/reports_status';


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

/* ========== ~~~~~~~~~~ REPORTS STATUS : ACTIONS ~~~~~~~~~~ ========== */

// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers

export const SET_REPORT_PROPERTIES = 'SET_REPORT_PROPERTIES';
export const RECEIVE_REPORT_DATA = 'RECEIVE_REPORT_DATA';
export const RUN_REPORT = 'RUN_REPORT';
export const CREATE_REPORT = 'CREATE_REPORT';
export const SET_SAVE_REPORT_PENDING = 'SET_SAVE_REPORT_PENDING';
export const SET_REPORT_SAVED = 'SET_REPORT_SAVED';
export const SET_RUN_REPORT_PENDING = 'SET_RUN_REPORT_PENDING';
export const SET_PROCESSING = 'SET_PROCESSING';
export const START_DOWNLOADING_REPORT = 'START_DOWNLOADING_REPORT';
export const END_DOWNLOADING_REPORT = 'END_DOWNLOADING_REPORT';
export const DISCARD_REPORT_CHANGES = 'DISCARD_REPORT_CHANGES';


export const setReportProperties = properties => ({
    type: SET_REPORT_PROPERTIES,
    properties
});
export const receiveReportData = reportData => ({
    type: RECEIVE_REPORT_DATA,
    reportData
});
export const setSaveReportPending = status => ({
    type: SET_SAVE_REPORT_PENDING,
    status
});
export const setReportSaved = status => ({
    type: SET_REPORT_SAVED,
    status
});
export const setRunReportPending = status => ({
    type: SET_RUN_REPORT_PENDING,
    status
});

export const setProcessing = status => ({
   type: SET_PROCESSING,
   status
});

// export const setSaveReport = data => ({
//     type: SAVE_REPORT,
//     data
// });
export const setRunReport = data => ({
    type: RUN_REPORT,
    data
});
export const setCreateReport = () => ({
    type: CREATE_REPORT
});
export const createReport = () => dispatch => (
    dispatch(batchActions([
        setCreateReport(),
        updateMode('create')
    ]))
);

export const startDownloadingReport = (reportType) => ({
    type: START_DOWNLOADING_REPORT,
    reportType
});

export const endDownloadingReport = (reportType) => ({
    type: END_DOWNLOADING_REPORT,
    reportType
});

export const discardReportChanges = () => ({
    type: DISCARD_REPORT_CHANGES
});

// HELPERS

const handleSaveSuccess = (data, successRoute) => dispatch => {
    dispatch(batchActions([
        receiveReportData(data),
        setSaveReportPending(false),
        setProcessing(false),
        displaySuccessMessage('We have successfully saved your report')
    ]));
    if (!!successRoute) successRoute()
};

const handleSaveFailure = failureRoute => dispatch => {
    dispatch(batchActions([
        displayErrorMessage('Something went wrong while saving your report'),
        setSaveReportPending(false),
        setProcessing(false)
    ]));
    if (failureRoute) failureRoute()
};



// THUNKS
const savingProcess = (bool) => dispatch => dispatch(
    batchActions([
        setSaveReportPending(bool),
        setProcessing(bool)]
));

export const saveReport = (reportData, successRoute, failureRoute) => dispatch => {
    dispatch(savingProcess(true));
    reportsAPIUtil.createReport(reportData)
        .then(response => dispatch(handleSaveSuccess(response.data, successRoute)))
        .catch(() => dispatch(handleSaveFailure(failureRoute))
        )
};

export const updateReport = (reportUUID, reportData, successRoute, failureRoute) => dispatch => {
    dispatch(savingProcess(true));
    reportsAPIUtil.updateReport(reportUUID, reportData)
        .then(response => dispatch(handleSaveSuccess(response.data, successRoute)))
        .catch(() => dispatch(handleSaveFailure(failureRoute)))
};

const runReportFail = () => dispatch => dispatch(
    batchActions([
        setRunReportPending(false),
        setProcessing(false),
        displayErrorMessage('Something went wrong while running your report') ]
    ));

const runProcess = bool => dispatch => dispatch(
    batchActions([
        setRunReportPending(bool),
        setProcessing(bool)]
    ));

export const runReport = (reportData) => dispatch => {
    dispatch(runProcess(true));
    return reportsAPIUtil.runReport(reportData)
        .then(response => {
            return dispatch(batchActions([
                setRunReport(response.data),
                updateMode('preview'),
                updatePageDetails('dashboard/reports/preview')
            ]));
        })
        .then(()=> dispatch(changePage('dashboard/reports/preview')))
        .then(()=> dispatch(setRunReportPending(false)))
        .then(()=> dispatch(setProcessing(false)))
        .then(() => dispatch(setLibraryProcessing(false)))
        .catch(() => dispatch(runReportFail()))
};
//-=-=-=-=-=- SAVE AND RUN -=-==-=-=-=---=--=-=-=//
const processSaveAndRun = (bool) => dispatch => {
    dispatch(
        batchActions([
            setRunReportPending(bool),
            setSaveReportPending(bool),
            setProcessing(bool)
        ]))
};

//I hate this function

export const saveAndRunReport = (reportData, reportUUID, accountUUID) => dispatch => {
    let saveAndRunResponse = {};
    dispatch(processSaveAndRun(true));
    if (reportUUID) {
        reportsAPIUtil.updateReport(reportUUID, reportData)
            .then(response => {
                saveAndRunResponse = response.data;
                dispatch(runReport(generateRunReportParamString(saveAndRunResponse)))
            })
            .then(()=> dispatch(receiveReportData(saveAndRunResponse)))
            .then(()=> dispatch(setSaveReportPending(false)))
            .then(()=> dispatch(getClientReportsData(accountUUID)))
            .catch(e => {
                dispatch(handleSaveFailure());
                dispatch(setSaveReportPending(false));
            })
    } else {
        reportsAPIUtil.createReport(reportData)
            .then(response => {
                saveAndRunResponse = response.data;
                dispatch(runReport(generateRunReportParamString(response.data)))
            })
            .then(()=> dispatch(receiveReportData(saveAndRunResponse)))
            .then(()=> dispatch(setSaveReportPending(false)))
            .then(()=> dispatch(getClientReportsData(accountUUID)))
            .catch(e => {
                dispatch(handleSaveFailure());
                dispatch(processSaveAndRun(false));
            })
    }
};


//replicated this so I can remove the success route on save and route to preview after run instead
// let PPAData = transpileDataForPPA(props.selectedReportData);
// if (props.selectedReportData.reportUUID) {
//     PPAData.accountUUID = null;
//     props.updateReport(props.selectedReportData.reportUUID, PPAData, () => props.getClientReportsData(props.accountUUID))
// } else {
//     props.saveReport(PPAData, () => props.getClientReportsData(props.accountUUID))
// }
// props.runReport(transpileDataForRMS(props.selectedReportData), () => props.moveToPage('dashboard/reports/preview'))


//-=-==-==-=-=- download report functionality -=-=-=-=-=-=--=-=-//

//message used when download link is not available due to a delay only created this variable to keep action below clean
const delayMessage = 'We are currently experiencing delays in ' +
    'retrieving your report data. Please try to export the report ' +
    'later in the day or contact your Account Manager for assistance.';

const downloadReportFail = (reportType) => dispatch => {
    dispatch(
        batchActions([
            endDownloadingReport(reportType),
            displayErrorMessage(`We were unable to download your ${reportType} report`)
        ])
    )
};

const downloadReportSuccess = (link, reportType) => dispatch => {
    downloadLink(link);
    return dispatch(
        batchActions([
            endDownloadingReport(reportType),
            displaySuccessMessage(`We have successfully downloaded your ${reportType} report`)]
        )
    );
};

const downloadReportDelayed = (reportType) => dispatch => {
    dispatch(
        batchActions([
            //copy for this message will have to be updated when i get information from amanda
            displayErrorMessage(delayMessage),
            endDownloadingReport(reportType)
        ])
    )
};



export const downloadReport = (data, reportType) => dispatch => {
    dispatch(startDownloadingReport(reportType));
    reportsAPIUtil.downloadReport(data)
            .then(response => {
                if(response.data.reportAvailable){
                    dispatch(downloadReportSuccess(response.data.link, reportType));
                } else {
                    dispatch(downloadReportDelayed(reportType));
                }
            }).catch(() => {
                dispatch(downloadReportFail(reportType));
            })
};

//-=-==-==-=-=- download report functionality end -=-=-=-=-=-=--=-=-//

